module.exports = __webpack_public_path__ + "img/chalk_14.31115807.png";